module.exports = __webpack_public_path__ + "assets/folder.5281f2334e2e7ec52190ea51e47d9a2b.png";